import clsx from "clsx";
import { ColoredPaperProps } from "../../surface/ColoredPaper/ColoredPaper.types";
import { BaseCardRoot } from "./BaseCard.styles";

export interface BaseCardProps {
    className?: string;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

function BaseCard({ className, children, color = "lavender", ...rest }: BaseCardProps & ColoredPaperProps) {
    return (
        <BaseCardRoot className={clsx("base-card", className)} color={color} {...rest}>
            {children}
        </BaseCardRoot>
    );
}

export default BaseCard;
